import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { RX_ALLOWED_STRING, RX_EMAIL } from '../../constants/regex.constants';

const defaultValues = {
	name: '',
	surnames: '',
	entity: '',
	email: '',
	privacyPolicy: [],
};

const resolver = yupResolver(
	yup.object().shape({
		name: yup
			.string()
			.required('Debe indicar su nombre')
			.test('valid-string', 'Debe indicar su nombre', (text) => RX_ALLOWED_STRING.test(String(text))),
		surnames: yup
			.string()
			.required('Debe indicar como mínimo un apellido')
			.test('valid-string', 'Debe indicar como mínimo un apellido', (text) =>
				RX_ALLOWED_STRING.test(String(text)),
			),
		email: yup
			.string()
			.required('Debe indicar una dirección válida de correo electrónico')
			.test('valid-mail', 'Debe indicar una dirección válida de correo electrónico', (text) =>
				RX_EMAIL.test(String(text)),
			),
		assist: yup.string().required('Debe seleccionar una opción'),
		entity: yup
			.string()
			.required('Debe indicar una entidad')
			.test('valid-string', 'Debe indicar una entidad', (text) => RX_ALLOWED_STRING.test(String(text))),
		privacyPolicy: yup.array().required('').min(1, ''),
	}),
);

export { defaultValues, resolver };
